import { useState } from "react";
import axios from '../api/axiosInstance';

function AdminAddUserModal({ open, onClose, onSuccess }) {
  const [form, setForm] = useState({
    account: "",
    password: "",
    name: "",
    birthday: "",
    gender: "M",
  });

  const token = localStorage.getItem("token");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const payload = {
    ...form,
    birthday: form.birthday === "" ? null : form.birthday,
  };

  const handleSubmit = async () => {
    try {
      await axios.post("/api/Admin/register", payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert("建立成功");
      onClose();
      if (onSuccess) onSuccess();
    } catch (err) {
      alert("建立失敗");
      console.error(err);
    }
  };

  if (!open) return null;

  return (
    <>
      <div className="modal show fade d-block" tabIndex="-1" role="dialog" style={{ zIndex: 1055 }}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">新增使用者</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <div className="mb-2">
                <label className="form-label">帳號</label>
                <input
                  type="text"
                  className="form-control mb-2"
                  name="account"
                  value={form.account}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">密碼</label>
                <input
                  type="password"
                  className="form-control mb-2"
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">姓名</label>
                <input
                  type="text"
                  className="form-control mb-2"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">生日</label>
                <input
                  type="date"
                  className="form-control mb-2"
                  name="birthday"
                  value={form.birthday}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">姓別</label>
                <select
                  className="form-select mb-2"
                  name="gender"
                  value={form.gender}
                  onChange={handleChange}
                >
                  <option value="M">男</option>
                  <option value="F">女</option>
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>取消</button>
              <button className="btn btn-primary" onClick={handleSubmit}>送出</button>
            </div>
          </div>
        </div>
      </div >
      <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>
    </>
  );
}

export default AdminAddUserModal;
